import getConfig from '../../../config';

export const routeSchemaMap = {
	appsRoute: '/apps',
	appsMainTabRoute: '/apps/mainAppsTab',
	appsPDPRoute: '/apps/mainAppsTab/product',
	appsPDPTabRoute: '/apps/mainAppsTab/product/pdpTab',
};

export const clientID = getConfig('CLIENT_ID');
